'use client'
import React, {useEffect} from 'react';
import {useForm} from 'react-hook-form';
import {Box, Flex} from '@chakra-ui/layout';
import {FormControl, FormErrorMessage, Input} from '@chakra-ui/react';
import {IconButton} from '@chakra-ui/button';
import {MdCheck} from 'react-icons/md';
import {forwardRef} from '@chakra-ui/system';
import useExperienceApi from '../lib/useExperienceApi';
import useTranslation from '../../lib/i18n/useTranslation';

const ExperienceForm = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const {
    hideSave,
    onValidityChange,
    onSubmitted,
    onSubmitting
  } = props;
  const {
    register,
    handleSubmit,
    errors,
    formState: { isSubmitting, isValid }
  } = useForm();
  const experienceApi = useExperienceApi();
  const onSubmit = async (data) => {
    try {
      if(onSubmitting) {
        onSubmitting();
      }
      const name = data.name;
      let newExperience;
      if(name) {
        newExperience = await experienceApi.insertExperience(name);
      }
      if(onSubmitted && newExperience) {
        onSubmitted(newExperience);
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    if(onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid]);
  return (
    <>
      <Box>
        <form onSubmit={handleSubmit(onSubmit)} >
          <Flex
            alignItems={'center'}
          >
            <FormControl isInvalid={errors && errors.name}>
              <Input
                placeholder={t('common.namePlaceholder')}
                {...register('name', {
                  required: true,
                  minLength: 3
                })}
              />
              <FormErrorMessage>{errors && errors.name}</FormErrorMessage>
            </FormControl>
            <IconButton
              style={{
                display: hideSave ? 'none' : 'inherit',
              }}
              ref={ref}
              icon={<MdCheck />}
              ml={2}
              type={'submit'}
              aria-label='check'
              variant='primary'
              isLoading={isSubmitting}
              isDisabled={!isValid}
            />
          </Flex>
        </form>
      </Box>
    </>
  );
});
export default ExperienceForm;
